import React, { useEffect, useRef } from 'react'
import './graciasPorContactar.scss'

function GraciasPorContactar() {
    const lineRefs = useRef([]);


    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });



        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);
    return (
        <div className="gracias-container">
            <h1 className="gracias-title header-title__main-page">¡Gracias por contactarnos!</h1>
            <div
                ref={el => lineRefs.current[0] = el}
                className="content__title-line gracias-line "
            />
            <p className="gracias-message header-subtitle__main-page">
                Hemos recibido tu mensaje y nos pondremos en contacto contigo lo antes posible.
            </p>
            <p className="gracias-note header-text__main-page">
                Mientras tanto, puedes explorar nuestro sitio o seguirnos en redes sociales.
            </p>
            <a href="/" className="header-text__main-page gracias-link">Volver al inicio &#8594;</a>
        </div>
    );
}

export default GraciasPorContactar